import { Reel } from "../../types";

const TTL_MS = 5 * 60 * 1000;

interface CacheEntry {
    reel: Reel;
    expiresAt: number;
}

const cache = new Map<number, CacheEntry>();

export function getCachedReel(id: number): Reel | null {
    const entry = cache.get(id);
    if (!entry) return null;
    if (Date.now() > entry.expiresAt) {
        cache.delete(id);
        return null;
    }
    return entry.reel;
}

export function setCachedReel(reel: Reel): void {
    cache.set(reel.id, { reel, expiresAt: Date.now() + TTL_MS });
}

export function setCachedReels(reels: Reel[]): void {
    reels.forEach(setCachedReel);
}
